var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-personal-info-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var step = ref.step;
    var goNextStep = ref.goNextStep;
    var goPreviousStep = ref.goPreviousStep;
    var briefFields = ref.briefFields;
    var isLoading = ref.isLoading;
    var isCompletingBrief = ref.isCompletingBrief;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
return [_c('activation-brief-personal-info-view',{attrs:{"brief":brief,"step":step,"is-loading":isLoading,"brief-fields":briefFields,"is-completing-brief":isCompletingBrief,"errors":errors,"error-message":errorMessage},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }